import React from 'react';
import { Button as ShButton, ButtonProps } from '@saleshandy/design-system';

const Button: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <ShButton {...rest}>{children}</ShButton>
);

export default Button;
